import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { MultiSelectComponent } from '../../common/ng-multiselect-dropdown/src/multiselect.component';
import { DateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { Cookie } from 'ng2-cookies';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { WebServiceService } from '../../shared/services/web-service.service';
import { MultiCompanyViewTokenService } from '../../shared/services/multi-company-view-token.service';

@Component({
  selector: 'app-pending-invoices-popup',
  templateUrl: './pending-invoices-popup.component.html',
  styleUrls: ['./pending-invoices-popup.component.scss'],
  providers: [WebServiceService, LocalStorageService, MultiCompanyViewTokenService]
})
export class PendingInvoicesPopupComponent implements OnInit, OnChanges, OnDestroy {

  @Input() parentRequestPayload: any = {};
  @Input() groupCompanyList: any[] = [];
  @Input() autoLoad: boolean = true;
  @Output() invoiceAction = new EventEmitter<{ action: string; invoice?: any; invoices?: any[]; reason?: string }>();
  @Output() closePopup = new EventEmitter<void>();

  CommonDataList: any;
  isProgressing: boolean = false;
  allInvoiceLIst: any = [];
  stillLoading: boolean = true;
  searchinput: any = '';
  isListVisible: boolean = true;
  selectedAll: boolean = false;
  notFoundMessage: any = 'No new Invoice for your approval';
  dropdownSettings: any = {};
  company_setup: any = {};
  setup_loaded: boolean = false;
  meta: any = {};
  activePage: number = 1;
  rowsPerPage: number = 20;
  currentPage: number = 1;
  paginationLoader: boolean = false;
  totalItems: number = 0;
  goToPageValue: any = '';
  goToPageNumber: any = '20';
  pageSetList: any = [
    { id: 0, display: '10', value: '10' },
    { id: 1, display: '15', value: '15' },
    { id: 0, display: '20', value: '20' },
    { id: 0, display: 'All', value: '' }
  ];
  invoice_raised_from_date: any = '';
  invoice_raised_to_date: any = '';
  action_type: any = '';
  companyThemeBlockColor: any = '';
  CompanyThemetextColor: any = '';
  country_data: any = {};
  commonVariableList: any = {
    modalDetails: { is_view: false, is_all: false }
  };
  flag: boolean = false;

  VendorArray: any = [];
  VenList: any = [];
  monthList: any = [];
  monthId: any = [];
  shipToLocationArray: any = [];
  ShiptoLocationList: any = [];
  ReqEmployeeArray: any = [];
  ReqEmployeeList: any = [];
  lobArray: any[] = [];
  lobModelList: any[] = [];
  lobLocationArray: any[] = [];
  lobLocationList: any[] = [];
  departmentArray: any[] = [];
  departmentList: any[] = [];
  companyArray: any[] = [];
  companyList: any[] = [];
  bulkConfirmMessage: string = '';
  pendingBulkAction: string = '';
  showBulkConfirmDialog: boolean = false;
  bulkRejectReason: string = '';
  bulkActionProgressing: boolean = false;
  batchProcessingInProgress: boolean = false;
  batchProcessingMessage: string = '';
  showBulkValidationErrorsDialog: boolean = false;
  aggregatedBulkValidationErrors: any[] = [];
  pendingApprovalList: any[] = [];
  isBulkApprovalAction: boolean = false;
  private readonly approvalDataBatchSize = 5;
  redirectInProgress: boolean = false;
  viewInProgress: boolean = false;
  homeTokenContext: { access_token: string; user_access_token: string } = null;
  companyData: any = { is_multiple: false, list: [], data: {}, searchComp: '', company_id: '' };
  navData: any = { is_other_project: false, link: '', data: {} };
  menuList: any = [];
  id: any = 0;
  private readonly updateInvoiceUrl = '/update-invoice';
  private filterMultiselectOutsideClickListener: ((event: MouseEvent) => void) | null = null;

  @ViewChildren(MultiSelectComponent)
  private filterMultiselects: QueryList<MultiSelectComponent>;

  @ViewChildren(MultiSelectComponent, { read: ElementRef })
  private filterMultiselectHosts: QueryList<ElementRef>;

  constructor(
    public webService: WebServiceService,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    public eesdesService: EesDesService,
    public setup: CompanySetupService,
    private dateAdapter: DateAdapter<Date>,
    private router: Router,
    private multiCompanyViewTokenService: MultiCompanyViewTokenService
  ) {}

  ngOnInit() {
    const t = this.eesdesService.get('country_data', localStorage.getItem('country_data'))
      ? this.eesdesService.get('country_data', localStorage.getItem('country_data'))
      : {};
    if (t.country_id !== '' && t.country_id !== undefined && t.country_id !== null) {
      this.country_data = t;
    }
    this.action_type = this._localStorageService.getDashboradAction()
      ? this._localStorageService.getDashboradAction()
      : '';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme()
      ? this._localStorageService.getCompanyTheme()
      : '#035168';
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor()
      ? this._localStorageService.getCompanyThemeColor()
      : '#FFFFFF';
    this.setCompanyFilterOptions();
    this.id = this._localStorageService.getUserId();
    this.getCompanies();
    this.GetCompanySetUpData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.groupCompanyList) {
      this.setCompanyFilterOptions();
    }
  }

  setCompanyFilterOptions() {
    this.companyArray = [];
    const list = this.groupCompanyList ? this.groupCompanyList : [];
    if (list) {
      for (const c of list) {
        const companyId = c.company_id != undefined ? c.company_id : c.id;
        const companyTitle =
          c.company_title || c.company_name || c.title || c.name || companyId;
        const companyCode = c.company_code ? ` (${c.company_code})` : '';
        this.companyArray.push({
          item_id: parseInt(companyId),
          item_text: `${companyTitle}${companyCode}`
        });
      }
    }
    this.companyArray = this.webService.removeDuplicates(this.companyArray, 'item_id');
  }

  GetCompanySetUpData() {
    this.isProgressing = true;
    const req = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId()
    };
    this.company_setup = {};
    this.setup_loaded = false;
    this.webService.commonPostMethod('Update_company_meta/ajax_getall_bycompany', req).subscribe(
      data => {
        if (data.status) {
          this.company_setup = data.response ? data.response : {};
          this.meta = data.response ? data.response : {};
          this.setup.setData(data.response);
          this.applyCompanySetupDefaults();
          this.setup_loaded = true;
          if (this.autoLoad) {
            this.getAllInvoicesForApproval(1, false, '', '0');
          }
        } else {
          this.toasterService.pop('error', 'Error', data.message);
        }
        this.isProgressing = false;
        this.setup_loaded = true;
      },
      () => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
        this.isProgressing = false;
        this.setup_loaded = true;
      }
    );
  }

  applyCompanySetupDefaults() {
    this.company_setup.custom_bill_location_name = this.company_setup.custom_bill_location_name
      ? this.company_setup.custom_bill_location_name
      : 'Bill Location';
    this.company_setup.custom_ship_location_name = this.company_setup.custom_ship_location_name
      ? this.company_setup.custom_ship_location_name
      : 'Ship Location';
    this.company_setup.is_bill_loc_hidden_in_inv = this.company_setup.is_bill_loc_hidden_in_inv
      ? this.company_setup.is_bill_loc_hidden_in_inv
      : '0';
    this.company_setup.invoice_bill_location_require_in_approval = this.company_setup
      .invoice_bill_location_require_in_approval
      ? this.company_setup.invoice_bill_location_require_in_approval
      : '0';
    this.company_setup.how_many_days_pending_in_dashboard = this.company_setup
      .how_many_days_pending_in_dashboard
      ? this.company_setup.how_many_days_pending_in_dashboard
      : 0;
    this.company_setup.invoice_ship_location_require_in_approval = this.company_setup
      .invoice_ship_location_require_in_approval
      ? this.company_setup.invoice_ship_location_require_in_approval
      : '0';
    this.company_setup.invoice_requested_by_require_in_approval = this.company_setup
      .invoice_requested_by_require_in_approval
      ? this.company_setup.invoice_requested_by_require_in_approval
      : '0';
    this.company_setup.invoice_receipt_date_name = this.company_setup.invoice_receipt_date_name
      ? this.company_setup.invoice_receipt_date_name
      : 'Invoice Receipt Date';
    this.company_setup.in_invoice_grn_no_custom_name = this.company_setup.in_invoice_grn_no_custom_name
      ? this.company_setup.in_invoice_grn_no_custom_name
      : 'GRN/QA No';
    this.company_setup.in_invoice_irn_no_custom_name = this.company_setup.in_invoice_irn_no_custom_name
      ? this.company_setup.in_invoice_irn_no_custom_name
      : 'IRN No';
    this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format
      ? this.company_setup.in_invoice_date_format
      : 'dd-mm-yyyy';
    this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code
      ? this.company_setup.comma_separate_currency_code
      : 'IND';
    this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price
      ? this.company_setup.is_enable_comma_separate_price
      : '0';
    this.company_setup.custom_name_for_lob = this.company_setup.custom_name_for_lob
      ? this.company_setup.custom_name_for_lob
      : 'LOB';
    this.company_setup.custom_name_for_loc = this.company_setup.custom_name_for_loc
      ? this.company_setup.custom_name_for_loc
      : 'Location';
    this.company_setup.custom_name_for_dept = this.company_setup.custom_name_for_dept
      ? this.company_setup.custom_name_for_dept
      : 'Department';
    this.company_setup.product_catalog_id = this.company_setup.product_catalog_id
      ? this.company_setup.product_catalog_id
      : '';
    if (
      this.company_setup.product_catalog_id != undefined &&
      this.company_setup.product_catalog_id != ''
    ) {
      this.company_setup.product_catalog_id = '1';
    }
    switch (this.company_setup.in_invoice_date_format.toLowerCase()) {
      case 'dd-mm-yyyy':
        this.dateAdapter.setLocale('en-GB');
        break;
      case 'mm-dd-yyyy':
        this.dateAdapter.setLocale('en-US');
        break;
      case 'yyyy-mm-dd':
        this.dateAdapter.setLocale('en-ZA');
        break;
      default:
        this.dateAdapter.setLocale('en-US');
        break;
    }
  }

  clearValue() {
    this.searchinput = '';
    this.getAllInvoicesForApproval(1, false, this.searchinput, '1');
  }

  selectAll(value) {
    if (value) {
      if (this.allInvoiceLIst) {
        for (const i of this.allInvoiceLIst) {
          i.isChecked = true;
        }
      }
    } else if (this.allInvoiceLIst) {
      for (const i of this.allInvoiceLIst) {
        i.isChecked = false;
      }
    }
    this.selectedAll = this.allInvoiceLIst.every(v => v.isChecked);
  }

  getSelectedLength(x, type) {
    this.checkIfAllSelected(type);
    const tmp = this.allInvoiceLIst.filter(v => v.isChecked);
    if (tmp && tmp.length > 0) {
      let show_multi_inv: any = '';
      for (const i of tmp) {
        i.show_multi_inv = i.show_multi_inv ? i.show_multi_inv : '0';
        if (show_multi_inv == '') {
          show_multi_inv = i.show_multi_inv ? i.show_multi_inv : '0';
        } else if (show_multi_inv != i.show_multi_inv) {
          x.isChecked = false;
          this.toasterService.pop('error', 'Error', 'Please select all invoices of same type');
          return false;
        }
      }
    }
  }

  checkIfAllSelected(type) {
    this.selectedAll = this.allInvoiceLIst.every((item: any) => item.isChecked == true);
  }

  get hasSelectedInvoices(): boolean {
    return (
      this.allInvoiceLIst &&
      this.allInvoiceLIst.some((item: any) => item.isChecked === true)
    );
  }

  getSelectedInvoices(): any[] {
    return this.allInvoiceLIst ? this.allInvoiceLIst.filter((item: any) => item.isChecked) : [];
  }

  getInvoiceCompanyId(invoice: any): string {
    if (!invoice) {
      return '';
    }
    const companyId =
      invoice.company_id != undefined && invoice.company_id != null && invoice.company_id !== ''
        ? invoice.company_id
        : invoice.project_company_id != undefined && invoice.project_company_id != null
          ? invoice.project_company_id
          : '';
    return companyId != null && companyId !== '' ? companyId.toString() : '';
  }

  hasSameCompanyIdForSelectedInvoices(): boolean {
    const selected = this.getSelectedInvoices();
    if (!selected || selected.length <= 1) {
      return true;
    }
    const firstCompanyId = this.getInvoiceCompanyId(selected[0]);
    if (firstCompanyId === '') {
      return false;
    }
    return selected.every((invoice: any) => this.getInvoiceCompanyId(invoice) === firstCompanyId);
  }

  openBulkConfirm(action: string) {
    const selected = this.getSelectedInvoices();
    if (!selected || selected.length <= 0) {
      this.toasterService.pop('info', 'Info', 'Please select at least one invoice');
      return;
    }
    if (!this.hasSameCompanyIdForSelectedInvoices()) {
      this.toasterService.pop(
        'info',
        'Info',
        'Only same company invoices will be approved or rejected'
      );
      return;
    }
    this.openApprovalConfirm(action, selected, true);
  }

  openApprovalConfirm(action: string, invoices: any[], isBulk: boolean) {
    if (!invoices || invoices.length <= 0) {
      this.toasterService.pop('info', 'Info', 'Please select at least one invoice');
      return;
    }
    this.pendingApprovalList = invoices;
    this.isBulkApprovalAction = isBulk;
    this.bulkRejectReason = '';
    this.pendingBulkAction = action;
    if (action === 'approve') {
      this.bulkConfirmMessage = isBulk
        ? `Do you want to approve ${invoices.length} selected invoice(s)?`
        : 'Do you want to approve this invoice?';
    } else {
      this.bulkConfirmMessage = isBulk
        ? `Do you want to reject ${invoices.length} selected invoice(s)?`
        : 'Do you want to reject this invoice?';
    }
    this.showBulkConfirmDialog = true;
  }

  confirmBulkActionOk() {
    const invoices = this.pendingApprovalList ? this.pendingApprovalList : [];
    if (!invoices || invoices.length <= 0) {
      this.cancelBulkAction();
      return;
    }
    if (this.isBulkApprovalAction && !this.hasSameCompanyIdForSelectedInvoices()) {
      this.toasterService.pop(
        'error',
        'Error',
        'Only same company invoices will be approved or rejected'
      );
      this.cancelBulkAction();
      return;
    }
    if (this.pendingBulkAction === 'reject') {
      if (!this.bulkRejectReason || !this.bulkRejectReason.toString().trim()) {
        this.toasterService.pop('info', 'Info', 'Please enter reject reason');
        return;
      }
    }
    const approvalType = this.pendingBulkAction === 'approve' ? '1' : '2';
    const dataForApproval = this.buildApprovalPayload(invoices, approvalType);
    this.approveRejectInvoice(dataForApproval, approvalType);
  }

  buildApprovalPayload(invoices: any[], type: string): any[] {
    const approvalStatus = type === '1' ? '1' : '2';
    const dataForApproval: any[] = [];
    if (!invoices) {
      return dataForApproval;
    }
    for (const invoice of invoices) {
      const item: any = {
        company_id: this.getInvoiceCompanyId(invoice),
        invoice_id: invoice.id != undefined && invoice.id != null ? invoice.id.toString() : '',
        approval_status: approvalStatus
      };
      if (approvalStatus === '1') {
        item.approval_remarks = '';
      } else {
        item.reason = this.bulkRejectReason ? this.bulkRejectReason.trim() : '';
      }
      dataForApproval.push(item);
    }
    return dataForApproval;
  }

  clearSelectedInvoices() {
    this.selectedAll = false;
    if (this.allInvoiceLIst) {
      for (const invoice of this.allInvoiceLIst) {
        invoice.isChecked = false;
      }
    }
  }

  cancelBulkAction() {
    this.showBulkConfirmDialog = false;
    this.pendingBulkAction = '';
    this.bulkConfirmMessage = '';
    this.bulkRejectReason = '';
    this.pendingApprovalList = [];
    this.isBulkApprovalAction = false;
  }

  setRowPage() {
    if (
      this.goToPageNumber === '' ||
      this.goToPageNumber === null ||
      this.goToPageNumber === undefined
    ) {
      const allCount =
        this.pageSetList[3] && this.pageSetList[3].value !== '' && this.pageSetList[3].value != null
          ? this.pageSetList[3].value
          : this.totalItems;
      this.rowsPerPage = allCount ? +allCount : this.totalItems || 20;
    } else {
      this.rowsPerPage = +this.goToPageNumber;
    }
    this.currentPage = 1;
    this.activePage = 1;
  }

  onRowsPerPageChange() {
    this.setRowPage();
    this.getAllInvoicesForApproval(1, false, this.searchinput, '1');
  }

  private chunkArray<T>(items: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];
    if (!items || items.length <= 0) {
      return chunks;
    }
    for (let i = 0; i < items.length; i += chunkSize) {
      chunks.push(items.slice(i, i + chunkSize));
    }
    return chunks;
  }

  getApprovalDataChunks(dataForApproval: any[]): any[][] {
    if (!dataForApproval || dataForApproval.length <= this.approvalDataBatchSize) {
      return dataForApproval && dataForApproval.length > 0 ? [dataForApproval] : [];
    }
    return this.chunkArray(dataForApproval, this.approvalDataBatchSize);
  }

  startBatchProcessing(message: string) {
    this.batchProcessingInProgress = true;
    this.batchProcessingMessage = message;
  }

  stopBatchProcessing() {
    this.batchProcessingInProgress = false;
    this.batchProcessingMessage = '';
  }

  getAllInvoicesForApproval(page: any, flag: boolean, search_query, is_search) {
    if (flag && (this.goToPageValue == '' || this.goToPageValue == null)) {
      this.toasterService.pop('info', 'Info', 'Please enter valid page number');
      return;
    }
    const multiVendor: any = [];
    const vList: any = this.VenList ? this.VenList : [];
    if (vList) {
      for (const x of vList) {
        multiVendor.push(x.item_id.toString());
      }
    }
    const multiRequestedBy: any = [];
    if (this.ReqEmployeeList) {
      for (const x of this.ReqEmployeeList) {
        multiRequestedBy.push(x.item_id.toString());
      }
    }
    const multiMonthId: any = [];
    if (this.monthId) {
      for (const x of this.monthId) {
        multiMonthId.push(x.item_id.toString());
      }
    }
    const multiShiptoLocationList: any = [];
    if (this.ShiptoLocationList) {
      for (const x of this.ShiptoLocationList) {
        multiShiptoLocationList.push(x.item_id.toString());
      }
    }
    const deptId: any = [];
    if (this.departmentList) {
      for (const x of this.departmentList) {
        deptId.push(x.item_id.toString());
      }
    }
    const multiLobLocation: any = [];
    if (this.lobLocationList) {
      for (const x of this.lobLocationList) {
        multiLobLocation.push(x.item_id.toString());
      }
    }
    const multiLob: any = [];
    if (this.lobModelList) {
      for (const x of this.lobModelList) {
        multiLob.push(x.item_id.toString());
      }
    }
    const requestObj: any = {
      userId:
        this._localStorageService.getUserId() == undefined
          ? '0'
          : this._localStorageService.getUserId(),
       company_id: this._localStorageService.getEmpCompanyId(),
      page_no: ((page - 1) * this.rowsPerPage).toString(),
      record_per_page: this.rowsPerPage,
      department: deptId ? deptId : [],
      location: multiLobLocation ? multiLobLocation : [],
      lob: multiLob ? multiLob : [],
      product_catalog_id: this.company_setup.product_catalog_id
        ? this.company_setup.product_catalog_id
        : '0',
      vendor_id: multiVendor ? multiVendor : [],
      requested_by: multiRequestedBy ? multiRequestedBy : [],
      month: multiMonthId ? multiMonthId : [],
      ship_to_location: multiShiptoLocationList ? multiShiptoLocationList : [],
      from_invoice_raised_date: this.invoice_raised_from_date
        ? this.webService.formatDate(this.invoice_raised_from_date, 'yy-mm-dd', '-')
        : '',
      to_invoice_raised_date: this.invoice_raised_to_date
        ? this.webService.formatDate(this.invoice_raised_to_date, 'yy-mm-dd', '-')
        : '',
      search_query: search_query ? search_query : '',
      is_search: is_search ? is_search : '0',
      action: this.action_type ? this.action_type : '',
      how_many_days_pending_in_dashboard:
        (this._localStorageService.getDashboradActionType()
          ? this._localStorageService.getDashboradActionType()
          : '') == '0'
          ? this.company_setup.how_many_days_pending_in_dashboard
            ? this.company_setup.how_many_days_pending_in_dashboard
            : ''
          : ''
    };
    const multiCompanyIds: any = [];
    if (this.companyList && this.companyList.length > 0) {
      for (const x of this.companyList) {
        multiCompanyIds.push(x.item_id.toString());
      }
      requestObj.company_ids = multiCompanyIds;
    } else if (this.parentRequestPayload) {
      const parentCompanyIds =
        this.parentRequestPayload.company_ids || this.parentRequestPayload.company_is || [];
      if (parentCompanyIds && parentCompanyIds.length > 0) {
        requestObj.company_ids = parentCompanyIds.map((x: any) => x.toString());
      }
    }
    if (
      (this._localStorageService.getDashboradActionType()
        ? this._localStorageService.getDashboradActionType()
        : '') == '1'
    ) {
      delete requestObj['how_many_days_pending_in_dashboard'];
    }

    this.paginationLoader = true;
    this.stillLoading = true;
    this.selectedAll = false;
    this.allInvoiceLIst = [];
    this.webService.commonPostMethod('all_company_analytical_data/invoices_pending_for_approval', requestObj).subscribe(
      data => {
        if (data.status) {
          this.pageSetList[3].value = data.count ? data.count : 0;
          this.allInvoiceLIst = data.response;
          if (this.allInvoiceLIst) {
            let tCount = 0;
            for (const j of this.allInvoiceLIst) {
              j.internal_loading = false;
              j.vendor_name = j.vendor_address ? j.vendor_address : '';
              j.requested_by =
                j.added_by_first_name +
                ' ' +
                j.added_by_last_name +
                ' ' +
                '(' +
                j.employee_code +
                ')';
              j.ship_to_location_name = j.ship_to_location_name ? j.ship_to_location_name : '';
              j.ship_name = j.ship_to_location_name;
              j.ship_location_code_9_digit = j.ship_location_code_9_digit
                ? j.ship_location_code_9_digit
                : '';
              if (
                j.ship_location_code_9_digit != undefined &&
                j.ship_location_code_9_digit != null
              ) {
                j.ship_name = j.ship_name + '(' + j.ship_location_code_9_digit + ')';
              }
              if (j.is_custom_ship_to_location == '1') {
                j.ship_name = j.custom_ship_to_location;
              }
              j.bill_to_location_name = j.bill_to_location_name ? j.bill_to_location_name : '';
              j.bill_name = j.bill_to_location_name;
              j.bill_to_location_code_9_digit = j.bill_to_location_code_9_digit
                ? j.bill_to_location_code_9_digit
                : '';
              if (
                j.bill_to_location_code_9_digit != undefined &&
                j.bill_to_location_code_9_digit != null
              ) {
                j.bill_name = j.bill_name + '(' + j.bill_to_location_code_9_digit + ')';
              }
              j.tCount = tCount;
              j.innerTableItems = false;
              j.innerTableApprovals = false;
              j.invoice_items = j.invoice_items ? j.invoice_items : [];
              j.approvals = j.invoice_approvals ? j.invoice_approvals : [];
              j.product_count = j.product_count ? j.product_count : '0';
              j.approval_count = j.approvals.length;
              j.is_multi_invoice = j.is_multi_invoice ? j.is_multi_invoice : '0';
              j.show_multi_inv = j.is_multi_invoice == 'YES' ? '1' : '0';
              tCount++;
            }
          }
          this.normalizeInvoiceList();
          this.paginationLoader = false;
          this.totalItems = parseInt(data.count);
          this.currentPage = page;
          this.activePage = page;
          this.flag = false;
        } else {
          this.toasterService.pop('error', 'Error', data.message);
        }
        this.closeFilterPanel();
        this.paginationLoader = false;
        this.stillLoading = false;
        this.webService.makeFocusById('pending_inv_search_id');
      },
      () => {
        this.paginationLoader = false;
        this.stillLoading = false;
      }
    );
  }

  normalizeInvoiceList() {
    if (!this.allInvoiceLIst) {
      return;
    }
    for (const i of this.allInvoiceLIst) {
      i.vendor_name =
        i.invoice_items.length > 0
          ? i.invoice_items[0].vendor_address
            ? i.invoice_items[0].vendor_address
            : ''
          : '';
      i.bill_name = i.bill_to_location;
      i.ship_name = i.ship_to_location;
      i.grn_list = i.grn_list ? i.grn_list : [];
      i.grn_list = this.webService.removeDuplicates(i.grn_list, 'cs_id');
      i.irn_list = i.irn_list ? i.irn_list : [];
      i.irn_list = this.webService.removeDuplicates(i.irn_list, 'cs_id');
      i.po_list = i.po_list ? i.po_list : [];
      i.po_list = this.webService.removeDuplicates(i.po_list, 'po_no');
      i.pr_list = i.pr_list ? i.pr_list : [];
      i.pr_list = this.webService.removeDuplicates(i.pr_list, 'pr_no');
      i.bill_name_list = i.bill_name_list ? i.bill_name_list : [];
      let bill_names = [];
      if (i.bill_name_list) {
        for (const j of i.bill_name_list) {
          bill_names.push({ name: j });
        }
      }
      bill_names = this.webService.removeDuplicates(bill_names, 'name');
      const b_n = bill_names.map(j => j.name);
      i.bill_name = b_n.join(',');
      i.ship_name_list = i.ship_name_list ? i.ship_name_list : [];
      let ship_names = [];
      if (i.ship_name_list) {
        for (const j of i.ship_name_list) {
          ship_names.push({ name: j });
        }
      }
      ship_names = this.webService.removeDuplicates(ship_names, 'name');
      const s_n = ship_names.map(j => j.name);
      i.ship_name = s_n.join(',');
      i.vendor_list = i.vendor_list ? i.vendor_list : [];
      let vendors = [];
      if (i.vendor_list) {
        for (const j of i.vendor_list) {
          vendors.push({ name: j });
        }
      }
      vendors = this.webService.removeDuplicates(vendors, 'name');
      const v_n = vendors.map(j => j.name);
      i.vendors_list = v_n.join(',');
    }
  }

  showPopup() {
    this.VenList = this.VenList ? this.VenList : [];
    this.setCompanyFilterOptions();
    // this.getVendors();
    this.getEmployeeList();
    this.monthNames();
    // this.getLocationList('');
    // this.getDepartmentList([]);
    // this.getLobList();
    // this.getLobLocationList([]);
    const w = window.innerWidth;
    const dynamicWidth = w < 600 ? 300 : 600;
    document.getElementById('pendingInv_id').style.width = `${dynamicWidth}px`;
    document.getElementById('pendingInv_showModel').style.display = 'block';
    setTimeout(() => this.bindFilterMultiselectOutsideClick(), 0);
  }

  hideFilter(val: any) {
    this.closeFilterPanel();
    if (val == 'clear') {
      this.VenList = [];
      this.invoice_raised_from_date = '';
      this.invoice_raised_to_date = '';
      this.ReqEmployeeList = [];
      this.monthId = [];
      this.ShiptoLocationList = [];
      this.lobLocationList = [];
      this.lobModelList = [];
      this.departmentList = [];
      this.companyList = [];
      this.getAllInvoicesForApproval(1, false, '', '0');
    }
  }

  closeFilterPanel() {
    this.unbindFilterMultiselectOutsideClick();
    this.closeAllFilterMultiselects();
    const filterEl = document.getElementById('pendingInv_id');
    const overlayEl = document.getElementById('pendingInv_showModel');
    if (filterEl) {
      filterEl.style.width = '0';
    }
    if (overlayEl) {
      overlayEl.style.display = 'none';
    }
  }

  /**
   * Invoice for approval uses the shared clickOutside directive on each multiselect.
   * Here the dashboard popup stops document bubble clicks, so we close open dropdowns
   * from this component using a capture-phase document listener while the filter is open.
   */
  private bindFilterMultiselectOutsideClick(): void {
    this.unbindFilterMultiselectOutsideClick();
    this.filterMultiselectOutsideClickListener = (event: MouseEvent) => {
      if (!this.isFilterPanelOpen()) {
        return;
      }
      const target = event.target as HTMLElement;
      if (!target) {
        return;
      }
      const components = this.filterMultiselects ? this.filterMultiselects.toArray() : [];
      const hosts = this.filterMultiselectHosts ? this.filterMultiselectHosts.toArray() : [];
      components.forEach((component, index) => {
        const host = hosts[index];
        if (host && !host.nativeElement.contains(target)) {
          this.closeFilterMultiselect(component);
        }
      });
    };
    document.addEventListener('click', this.filterMultiselectOutsideClickListener, true);
  }

  private unbindFilterMultiselectOutsideClick(): void {
    if (this.filterMultiselectOutsideClickListener) {
      document.removeEventListener('click', this.filterMultiselectOutsideClickListener, true);
      this.filterMultiselectOutsideClickListener = null;
    }
  }

  private isFilterPanelOpen(): boolean {
    const overlay = document.getElementById('pendingInv_showModel');
    return !!(overlay && overlay.style.display === 'block');
  }

  private closeFilterMultiselect(component: MultiSelectComponent): void {
    component.closeDropdown();
    const childCdr = (component as any).cdr;
    if (childCdr) {
      childCdr.markForCheck();
    }
  }

  private closeAllFilterMultiselects(): void {
    if (!this.filterMultiselects) {
      return;
    }
    this.filterMultiselects.forEach(component => this.closeFilterMultiselect(component));
  }

  getVendors() {
    if (this.VendorArray.length > 0) {
      return;
    }
    const requestObj = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId(),
      user_id: this._localStorageService.getUserId()
    };
    this.webService.commonPostMethod('vendors/ajax_get_vendors_dropdown', requestObj).subscribe(
      data => {
        const vendorData: any = data.response;
        if (vendorData) {
          for (const x of vendorData) {
            this.VendorArray.push({
              item_id: parseInt(x.vendor_id),
              item_text: x.first_name + ' ' + x.last_name + ' (' + x.vendor_code + ')'
            });
          }
        }
        this.VendorArray = this.webService.removeDuplicates(this.VendorArray, 'item_id');
      },
      () => {}
    );
  }

  monthNames() {
    const MonthArray = [
      { month_id: '1', month_name: 'January' },
      { month_id: '2', month_name: 'February' },
      { month_id: '3', month_name: 'March' },
      { month_id: '4', month_name: 'April' },
      { month_id: '5', month_name: 'May' },
      { month_id: '6', month_name: 'June' },
      { month_id: '7', month_name: 'July' },
      { month_id: '8', month_name: 'August' },
      { month_id: '9', month_name: 'September' },
      { month_id: '10', month_name: 'October' },
      { month_id: '11', month_name: 'November' },
      { month_id: '12', month_name: 'December' }
    ];
    this.monthList = MonthArray.map(x => ({
      item_id: parseInt(x.month_id),
      item_text: x.month_name
    }));
    this.monthList = this.webService.removeDuplicates(this.monthList, 'item_id');
  }

  getLocationList(searchData?: any) {
    const requestObj = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId(),
      search_query: searchData ? searchData : ''
    };
    this.webService.commonPostMethod('/locations/ajax_get_all_location_pr_v2', requestObj).subscribe(
      data => {
        if (data.status) {
          const costCenterData: any = data.locations;
          if (costCenterData) {
            for (const x of costCenterData) {
              this.shipToLocationArray.push({
                item_id: parseInt(x.id),
                item_text: `${x.location_nickname_9_digit} (${x.location_code_9_digit})`
              });
            }
          }
          this.shipToLocationArray = this.webService.removeDuplicates(
            this.shipToLocationArray,
            'item_id'
          );
        }
      },
      () => {}
    );
  }

  getEmployeeList(search_query?: any) {
    search_query = search_query ? search_query : '';
    if (search_query.length <= 3 && search_query != '') {
      return;
    }
    const requestObj = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId(),
      search_query: search_query ? search_query : '',
      is_backend_search: 1
    };
    this.webService.commonPostMethod('companies/ajax_getempbycmp_for_android', requestObj).subscribe(
      data => {
        if (data.status) {
          const response = data.response ? data.response : [];
          this.ReqEmployeeArray = response.map(x => ({
            item_id: parseInt(x.employee_id),
            item_text: x.first_name + ' ' + x.last_name + ' (' + x.employeecode + ')'
          }));
          this.ReqEmployeeArray = this.webService.removeDuplicates(
            this.ReqEmployeeArray,
            'item_id'
          );
        }
      },
      () => {}
    );
  }

  getDepartmentList(lobList) {
    this.departmentArray = [];
    const locationCodes: any[] = [];
    const selectedLocations: any[] = this.lobLocationList ? this.lobLocationList : [];
    for (const x of selectedLocations) {
      // API expects location_code but key should remain location_id
      const codeFromItem = x && x.item_code ? x.item_code.toString() : '';
      if (codeFromItem) {
        locationCodes.push(codeFromItem);
        continue;
      }
      const text = x && x.item_text ? x.item_text.toString() : '';
      const match = text ? text.match(/\(([^)]+)\)\s*$/) : null;
      const codeFromText = match && match[1] ? match[1].trim() : '';
      if (codeFromText) {
        locationCodes.push(codeFromText);
      }
    }
    const multiLob: any = [];
    if (this.lobModelList) {
      for (const x of this.lobModelList) {
        multiLob.push(x.item_id.toString());
      }
    }
    const requestObj = {
      company_id: this._localStorageService.getEmpCompanyId()
        ? this._localStorageService.getEmpCompanyId()
        : 0,
      // Backend wants location_code but under key location_id
      location_id: locationCodes,
      lob_id: multiLob ? multiLob : []
    };
    this.webService.commonPostMethod('/department/department_dropdown', requestObj).subscribe(
      data => {
        if (data.status) {
          const departmentData: any = data.response;
          const departmentArray = [];
          if (departmentData) {
            for (const x of departmentData) {
              departmentArray.push({
                item_id: parseInt(x.id),
                item_text: `${x.department_name} (${x.department_code})`
              });
            }
            this.departmentArray = departmentArray;
          }
          this.departmentArray = this.webService.removeDuplicates(
            this.departmentArray,
            'item_id'
          );
        }
      },
      () => {}
    );
  }

  getLobLocationList(lobModelList, searchData?: any) {
    const multiLob: any = [];
    if (this.lobModelList) {
      for (const x of this.lobModelList) {
        multiLob.push(x.item_id.toString());
      }
    }
    const requestObj = {
      company_id: this._localStorageService.getEmpCompanyId()
        ? this._localStorageService.getEmpCompanyId()
        : 0,
      type: '6_digit',
      lob_id: multiLob ? multiLob : [],
      search_query: searchData ? searchData : ''
    };
    this.webService.commonPostMethod('/locations/location_dropdown', requestObj).subscribe(
      data => {
        if (data.status) {
          const costCenterData: any = data.locations;
          const lobLocationArray = [];
          if (costCenterData) {
            for (const x of costCenterData) {
              lobLocationArray.push({
                item_id: parseInt(x.id),
                item_text: `${x.location_nickname_9_digit} (${x.location_code})`,
                item_code: x.location_code
              });
            }
            this.lobLocationArray = lobLocationArray;
          }
          this.lobLocationArray = this.webService.removeDuplicates(
            this.lobLocationArray,
            'item_id'
          );
        }
      },
      () => {}
    );
  }

  getLobList() {
    this.lobArray = [];
    this.webService.commonPostMethod('lob/approved_lob', {}).subscribe(
      data => {
        if (data.status) {
          const temp: any = data.response;
          if (temp) {
            for (const i of temp) {
              i.name = i.lob_name;
              this.lobArray.push({
                item_id: parseInt(i.id),
                item_text: `${i.name} (${i.cs_id})`
              });
            }
          }
          this.lobArray = this.webService.removeDuplicates(this.lobArray, 'item_id');
        }
      },
      () => {}
    );
  }

  onItemSelect(items: any) {}
  onSelectAll(items: any) {}
  onDeselctAll(elem: any) {}
  onLOBDeSelect(event: any) {
    this.lobLocationList = [];
    this.departmentList = [];
  }
  onLoblocation(event: any) {
    this.departmentList = [];
  }
  onDeSelect1(data) {
    this.departmentList = [];
  }
  onDeSelect2(data) {
    this.lobLocationList = [];
  }
  selectAllLobItems() {
    this.lobModelList = [...this.lobArray];
    this.getLobLocationList(this.lobModelList, '');
    this.getDepartmentList(this.lobModelList);
  }
  selectAllLobItems1() {
    this.lobLocationList = [...this.lobLocationArray];
    this.getDepartmentList(this.lobLocationList);
  }
  clearLobModelList() {
    this.lobModelList = [];
  }

  private openViewModal(modalConfig: any, invoice?: any) {
    const companyId = invoice ? this.getInvoiceCompanyId(invoice) : '';
    if (companyId) {
      modalConfig.company_id = companyId;
      if (modalConfig.data) {
        modalConfig.data.company_id = companyId;
      }
    }
    this.commonVariableList.modalDetails = modalConfig;
    if (modalConfig.is_view !== undefined) {
      this.commonVariableList.modalDetails.is_view = modalConfig.is_view;
    }
    if (modalConfig.is_all !== undefined) {
      this.commonVariableList.modalDetails.is_all = modalConfig.is_all;
    }
  }

  showAllData(data, currentpage, invoice?: any) {
    this.currentPage = currentpage;
    const tmp = this.allInvoiceLIst.filter(v => v.id == data);
    let show_multi_inv = '0';
    let rowInvoice = invoice;
    if (tmp != undefined && tmp.length > 0) {
      show_multi_inv = tmp[0].show_multi_inv;
      if (!rowInvoice) {
        rowInvoice = tmp[0];
      }
    }
    this.openViewModal(
      {
        data: { id: data, show_multi_inv: show_multi_inv },
        id: 'invoicereport',
        name: 'Invoice Details',
        Desscription: 'Invoice',
        is_view: false,
        is_all: true,
        is_all_company_view: '1',
        is_setup: this.setup_loaded,
        setup: this.setup.getData(),
        meta: this.meta
      },
      rowInvoice
    );
  }

  viewRow(event: any) {
    if (event && event.action == 'close') {
      this.commonVariableList.modalDetails.is_all = false;
      this.restoreHomeTokenContext();
    }
  }

  ngOnDestroy() {
    this.unbindFilterMultiselectOutsideClick();
    this.restoreHomeTokenContext();
    this.multiCompanyViewTokenService.clearCache();
  }

  getCurrentCompanyId(): string {
    return this.eesdesService.get('company_id', localStorage.getItem('company_id'))
      ? this.eesdesService.get('company_id', localStorage.getItem('company_id')).toString()
      : '';
  }

  saveHomeTokenContext() {
    if (this.homeTokenContext) {
      return;
    }
    this.homeTokenContext = {
      access_token: this.eesdesService.get('access_token', localStorage.getItem('access_token'))
        ? this.eesdesService.get('access_token', localStorage.getItem('access_token'))
        : '',
      user_access_token: this.eesdesService.get('user_access_token', localStorage.getItem('user_access_token'))
        ? this.eesdesService.get('user_access_token', localStorage.getItem('user_access_token'))
        : ''
    };
  }

  restoreHomeTokenContext() {
    if (!this.homeTokenContext) {
      return;
    }
    if (this.homeTokenContext.access_token) {
      Cookie.set('access_token', this.homeTokenContext.access_token);
      document.cookie = 'access_token=' + this.homeTokenContext.access_token + ';secure';
      localStorage.setItem('access_token', this.eesdesService.set(this.homeTokenContext.access_token));
      this.setHttpCookie({
        action: 'set',
        cookie_name: 'access_token',
        cookie_value: this.eesdesService.set(this.homeTokenContext.access_token, 'access_token'),
        expire: '72000'
      });
    }
    if (this.homeTokenContext.user_access_token) {
      localStorage.setItem(
        'user_access_token',
        this.eesdesService.set(this.homeTokenContext.user_access_token)
      );
    }
    this.homeTokenContext = null;
    this.multiCompanyViewTokenService.clearActiveViewCompanyId();
  }

  applyTemporaryTokens(accessToken: string, userAccessToken: string, viewCompanyId?: string) {
    Cookie.set('access_token', accessToken);
    document.cookie = 'access_token=' + accessToken + ';secure';
    localStorage.setItem('access_token', this.eesdesService.set(accessToken));
    this.setHttpCookie({
      action: 'set',
      cookie_name: 'access_token',
      cookie_value: this.eesdesService.set(accessToken, 'access_token'),
      expire: '72000'
    });
    if (userAccessToken) {
      localStorage.setItem('user_access_token', this.eesdesService.set(userAccessToken));
    }
    if (viewCompanyId) {
      this.multiCompanyViewTokenService.setActiveViewCompanyId(viewCompanyId);
    }
  }

  fetchViewTokensForCompany(companyId: string, onSuccess: () => void) {
    this.multiCompanyViewTokenService.getOrFetchTokens(companyId).subscribe(
      tokens => {
        this.applyTemporaryTokens(tokens.access_token, tokens.user_access_token, companyId);
        onSuccess();
      },
      error => {
        this.viewInProgress = false;
        this.restoreHomeTokenContext();
        const message =
          typeof error === 'string' ? error : error && error.message ? error.message : 'Something Went Wrong';
        this.toasterService.pop('error', 'Error', message);
      }
    );
  }

  openInvoiceView(invoice: any) {
    this.showAllData(invoice.id, this.currentPage, invoice);
    this.invoiceAction.emit({ action: 'view', invoice });
  }

  onApprove(invoice: any) {
    if (!invoice) {
      return;
    }
    this.openApprovalConfirm('approve', [invoice], false);
  }

  onReject(invoice: any) {
    if (!invoice) {
      return;
    }
    this.openApprovalConfirm('reject', [invoice], false);
  }

  onView(invoice: any) {
    if (!invoice || this.viewInProgress) {
      return;
    }
    const targetCompanyId = this.getInvoiceCompanyId(invoice);
    if (!targetCompanyId) {
      this.toasterService.pop('error', 'Error', 'Company not found for this invoice');
      return;
    }
    if (+targetCompanyId === +this.getCurrentCompanyId()) {
      this.openInvoiceView(invoice);
      return;
    }
    this.viewInProgress = true;
    this.saveHomeTokenContext();
    this.fetchViewTokensForCompany(targetCompanyId, () => {
      this.viewInProgress = false;
      this.openInvoiceView(invoice);
    });
  }

  private setInvoiceUpdateRedirectContext(invoice: any) {
    const invoiceId =
      invoice.id != undefined && invoice.id != null
        ? invoice.id.toString()
        : invoice.invoice_id != undefined && invoice.invoice_id != null
          ? invoice.invoice_id.toString()
          : '';
    localStorage.setItem('invoice_id', invoiceId);
    localStorage.setItem('show_multi_inv', invoice.show_multi_inv ? invoice.show_multi_inv : '0');
    localStorage.setItem('invoice_screen', 'INVOICE_APPROVAL');
    localStorage.setItem('invoice_for_approval_screen', 'edit');
  }

  onRedirect(invoice: any) {
    if (!invoice || this.redirectInProgress) {
      return;
    }
    const targetCompanyId = this.getInvoiceCompanyId(invoice);
    if (!targetCompanyId) {
      this.toasterService.pop('error', 'Error', 'Company not found for this invoice');
      return;
    }
    const currentCompanyId = this.eesdesService.get('company_id', localStorage.getItem('company_id'))
      ? this.eesdesService.get('company_id', localStorage.getItem('company_id')).toString()
      : '';
    this.setInvoiceUpdateRedirectContext(invoice);
    this.closePopup.emit();
    localStorage.setItem(
      'dashboardAction',
      this.webService.set('', 'dashboardAction')
    );
    if (+targetCompanyId !== +currentCompanyId) {
      this.redirectInProgress = true;
      this.navData = { is_other_project: false, link: this.updateInvoiceUrl, data: {} };
      this.setCompany(targetCompanyId);
    } else {
      this.webService.redirectURL(this.updateInvoiceUrl);
    }
  }

  getCompanies() {
    const requestObj = {
      emp_id: this._localStorageService.getUserId(),
      company_id: '0'
    };
    this.companyData.list = [];
    this.webService
      .commonPostMethod('employees/ajax_getsingemp_companies_details', requestObj)
      .subscribe(
        data => {
          if (data.status == true) {
            this.companyData.data = data.empdata ? data.empdata : { companies: [] };
            if (this.companyData.data.companies) {
              for (const i of this.companyData.data.companies) {
                i.name = i.company_title + '(' + i.company_code + ')';
                i.id = i.company_id.toString();
              }
            }
            this.companyData.list = this.companyData.data.companies
              ? this.companyData.data.companies
              : [];
          }
        },
        () => {}
      );
  }

  setCompany(companyId: any) {
    try {
      const companyIdStr = companyId != null ? companyId.toString() : '';
      const companyRecord = this.companyData.list.filter((v: any) => v.id == companyIdStr)[0];
      if (!companyRecord) {
        this.redirectInProgress = false;
        this.toasterService.pop('error', 'Error', 'Unable to switch company. Please try again.');
        return;
      }
      localStorage.removeItem('menus');
      localStorage.removeItem('is_menu');
      localStorage.removeItem('costcenters');
      this.setLocalStorage(companyRecord);
    } catch (err) {
      this.redirectInProgress = false;
      console.warn(err);
    }
  }

  setLocalStorage(data: any) {
    data.company_setup = data.company_setup ? data.company_setup : {};
    sessionStorage.setItem('company_id', data.company_id);
    if (this.eesdesService.get('ven_role', localStorage.getItem('ven_role')) == 'vendor') {
      this.setVendorDetails(data);
      localStorage.setItem('company_id', this.eesdesService.set(data.company_id));
      localStorage.setItem('emp_role', this.eesdesService.set('vendor'));
      localStorage.setItem('company_code', this.eesdesService.set(data.company_code));
      localStorage.setItem('company_title', this.eesdesService.set(data.company_title));
      localStorage.setItem('company_logo', this.eesdesService.set(data.company_logo));
      localStorage.setItem('company_theme', this.eesdesService.set(data.company_theme));
      localStorage.setItem('company_theme_text', this.eesdesService.set(data.company_theme_text));
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT
        ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT
        : 10;
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup
        .enable_strict_auto_logout_policy
        ? data.company_setup.enable_strict_auto_logout_policy
        : '0';
      localStorage.setItem(
        'enable_strict_auto_logout_policy',
        data.company_setup.enable_strict_auto_logout_policy
      );
    } else {
      this.setEmployeeDetails(data);
      localStorage.setItem('company_id', this.eesdesService.set(data.company_id));
      localStorage.setItem('emp_role', this.eesdesService.set(data.employee_role));
      localStorage.setItem('company_title', this.eesdesService.set(data.company_title));
      localStorage.setItem('company_code', this.eesdesService.set(data.company_code));
      localStorage.setItem('company_logo', this.eesdesService.set(data.company_logo));
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT
        ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT
        : 10;
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup
        .enable_strict_auto_logout_policy
        ? data.company_setup.enable_strict_auto_logout_policy
        : '0';
      localStorage.setItem(
        'enable_strict_auto_logout_policy',
        data.company_setup.enable_strict_auto_logout_policy
      );
      localStorage.setItem('company_theme', this.eesdesService.set(data.company_theme));
      localStorage.setItem('company_theme_text', this.eesdesService.set(data.company_theme_text));
    }
    this.getAccessToken();
  }

  setVendorDetails(data: any) {
    localStorage.setItem('emp_role', this.eesdesService.set('vendor'));
    sessionStorage.setItem('company_id', data.company_id);
    localStorage.setItem('company_id', this.eesdesService.set(data.company_id));
    localStorage.setItem('emp_role', this.eesdesService.set('vendor'));
    if (this.companyData.list) {
      for (const j of this.companyData.list) {
        if (j.company_id == data.company_id) {
          localStorage.setItem('employee_code', this.eesdesService.set(j.vendor_code));
          localStorage.setItem('company_title', this.eesdesService.set(j.company_title));
          localStorage.setItem('company_code', this.eesdesService.set(j.company_code));
          localStorage.setItem('company_logo', this.eesdesService.set(j.company_logo));
          localStorage.setItem('emp_role', this.eesdesService.set('vendor'));
        }
      }
    }
    window.location.reload();
  }

  setEmployeeDetails(data: any) {
    if (this.companyData.data && this.companyData.data.companies) {
      for (const j of this.companyData.data.companies) {
        if (j.company_id == data.company_id) {
          this.companyData.data.employee_role = j.employee_role;
          this.companyData.data.employee_code = j.employee_code;
          this.companyData.data.company_id = j.company_id;
          this.companyData.data.company_title = j.company_title;
          this.companyData.data.company_code = j.company_code ? j.company_code : '';
          this.companyData.data.company_logo = j.company_logo;
          localStorage.setItem('employee_code', this.eesdesService.set(j.employee_code));
          j.company_setup = j.company_setup ? j.company_setup : {};
          j.company_setup.MINUTES_UNITL_AUTO_LOGOUT = j.company_setup.MINUTES_UNITL_AUTO_LOGOUT
            ? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT
            : 10;
          localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', j.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
          j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy
            ? j.company_setup.enable_strict_auto_logout_policy
            : '0';
          localStorage.setItem(
            'enable_strict_auto_logout_policy',
            j.company_setup.enable_strict_auto_logout_policy
          );
        }
      }
    }
    localStorage.setItem('ven_role', this.eesdesService.set(''));
  }

  getAccessToken() {
    const requestObj = {
      company_id: this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        ? this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        : '0'
    };
    this.webService.commonPostMethod('Companies/company_get_token', requestObj).subscribe(
      data => {
        if (data.status) {
          Cookie.set('access_token', data.response);
          document.cookie = 'access_token=' + data.response + ';secure';
          localStorage.setItem('access_token', this.eesdesService.set(data.response));
          this.setHttpCookie({
            action: 'set',
            cookie_name: 'access_token',
            cookie_value: this.eesdesService.set(data.response, 'access_token'),
            expire: '72000'
          });
          this.newGetUserAccessToken();
          this.getUserDetailsForDepartment();
        } else {
          this.redirectInProgress = false;
          this.toasterService.pop('error', 'Error', data.message);
          window.localStorage.clear();
          window.location.reload();
        }
      },
      () => {
        this.redirectInProgress = false;
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  getUserDetailsForDepartment() {
    const requestObj = {
      company_id: this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        ? this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        : '0',
      emp_id: this.id ? this.id : ''
    };
    this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).subscribe(
      data => {
        if (data.status == true && data.empdata) {
          if (data.empdata.cost_centers && data.empdata.cost_centers.length > 0) {
            const costcenters = data.empdata.cost_centers.filter(
              (v: any) => v.company_id == this._localStorageService.getEmpCompanyId()
            );
            if (costcenters) {
              for (const i of costcenters) {
                i.is_administrative_location = i.is_administrative_location
                  ? i.is_administrative_location
                  : '0';
                i.is_sez = i.is_sez ? i.is_sez : '0';
              }
            }
            localStorage.setItem('costcenters', this.eesdesService.set(JSON.stringify(costcenters)));
          }
          if (data.empdata.companies) {
            for (const j of data.empdata.companies) {
              if (j.employee_id == this.id) {
                j.company_setup = j.company_setup ? j.company_setup : {};
                j.company_setup.MINUTES_UNITL_AUTO_LOGOUT = j.company_setup.MINUTES_UNITL_AUTO_LOGOUT
                  ? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT
                  : 10;
                localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', j.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
                j.company_setup.enable_strict_auto_logout_policy = j.company_setup
                  .enable_strict_auto_logout_policy
                  ? j.company_setup.enable_strict_auto_logout_policy
                  : '0';
                localStorage.setItem(
                  'enable_strict_auto_logout_policy',
                  j.company_setup.enable_strict_auto_logout_policy
                );
                localStorage.setItem(
                  'department_id',
                  this.eesdesService.set(j.department ? j.department : '')
                );
                localStorage.setItem(
                  'department_name',
                  this.eesdesService.set(j.department_name ? j.department_name : '')
                );
                localStorage.setItem(
                  'profile_image',
                  this.eesdesService.set(j.profile_image ? j.profile_image : '')
                );
              }
            }
          }
        }
      },
      () => {}
    );
  }

  setHttpCookie(payload: any) {
    this.webService.commonPostMethod('login/cookies', payload).subscribe(
      () => {},
      () => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  newGetUserAccessToken() {
    const requestObj = {
      company_id: this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        ? this.eesdesService.get('company_id', localStorage.getItem('company_id'))
        : '0'
    };
    this.webService.commonPostMethod('User_session_management/generate_token', requestObj).subscribe(
      data => {
        if (data.status) {
          localStorage.setItem('user_access_token', this.eesdesService.set(data.response));
          this.getMenuList();
        } else if (data.already_active) {
          this.getMenuList();
        } else {
          if (
            this.eesdesService.get('company_id', localStorage.getItem('company_id')) == null ||
            this.eesdesService.get('company_id', localStorage.getItem('company_id')) == '0'
          ) {
            this.getMenuList();
          } else {
            this.redirectInProgress = false;
            this.toasterService.pop('error', 'Error', data.message);
            window.localStorage.clear();
            window.location.href = window.location.href;
          }
        }
      },
      () => {
        this.redirectInProgress = false;
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  getMenuList() {
    let roleId = '';
    if (this._localStorageService.getUserRole() == 'administrator') {
      roleId = '0';
    } else {
      roleId =
        this._localStorageService.getEmpRoleId() == undefined ||
        this._localStorageService.getEmpRoleId() == null
          ? '0'
          : this._localStorageService.getEmpRoleId();
    }
    const req = {
      id: roleId,
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined ||
        this._localStorageService.getEmpCompanyId() == null
          ? '0'
          : this._localStorageService.getEmpCompanyId()
    };
    this.webService.commonPostMethod('User_Roles/ajax_menu_items_by_user_role', req).subscribe(
      data => {
        this.redirectInProgress = false;
        if (data.status) {
          let temp: any = data.response ? data.response : [];
          if (temp) {
            for (const i of temp) {
              if (i.submenu) {
                for (const j of i.submenu) {
                  if (j.aurl == '/bug-master') {
                    j.menuitemname = 'Bug Master';
                  }
                  if (j.aurl == '/my-bug-master') {
                    j.menuitemname = 'My ' + 'Bug Master';
                  }
                }
              }
            }
          }
          this.menuList = temp;
          const comArray = this.companyData.list.filter(
            (v: any) => v.company_id == this._localStorageService.getEmpCompanyId()
          );
          localStorage.setItem('companies', this.eesdesService.set(JSON.stringify(comArray ? comArray : [])));
          localStorage.setItem('menus', this.eesdesService.set(JSON.stringify(this.menuList)));
          localStorage.setItem('is_menu', this.eesdesService.set('1'));
          if (this.menuList.length <= 0) {
            this.toasterService.pop('warning', 'Warning', 'You are not allowed to access this page');
            this.router.navigate(['/login']);
            return;
          }
          if (this.navData.is_other_project == false && this.navData.link != '') {
            this.webService.redirectURL(this.navData.link);
          }
          if (this.navData.is_other_project == true && this.navData.link != '') {
            window.location.href = this.navData.link;
          }
        }
      },
      () => {
        this.redirectInProgress = false;
      }
    );
  }

  refreshList() {
    this.getAllInvoicesForApproval(this.currentPage, false, this.searchinput, '1');
  }
  approveRejectInvoice(dataForApproval: any[], type: string) {
    if (!dataForApproval || dataForApproval.length <= 0) {
      this.toasterService.pop('info', 'Info', 'Please select at least one invoice');
      return;
    }
    this.resetBulkValidationErrors();
    const dataChunks = this.getApprovalDataChunks(dataForApproval);
    this.bulkActionProgressing = true;
    this.showBulkConfirmDialog = false;
    if (dataChunks.length <= 1) {
      this.submitBulkApprovalRequest(dataForApproval, type, false);
      return;
    }
    this.startBatchProcessing('Please wait, processing your request');
    this.submitBulkApprovalInBatches(dataChunks, type, 0, '');
  }

  submitBulkApprovalRequest(dataForApproval: any[], type: string, isBatched: boolean) {
    const requestObj = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId(),
      data_for_approval: dataForApproval
    };
    this.webService
      .commonPostMethod('all_company_analytical_data/multi_company_bulk_invoice_approval', requestObj)
      .subscribe(
        data => {
          if (!isBatched) {
            this.bulkActionProgressing = false;
          }
          this.appendBulkValidationErrorsFromResponse(data);
          if (!isBatched) {
            const defaultMessage =
              type === '1'
                ? 'Invoice(s) approved successfully'
                : 'Invoice(s) rejected successfully';
            const message = (data && data.message) || defaultMessage;
            this.completeBulkApprovalAfterRequests(message);
          }
        },
        () => {
          if (!isBatched) {
            this.bulkActionProgressing = false;
            this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          }
        }
      );
  }

  submitBulkApprovalInBatches(
    dataChunks: any[][],
    type: string,
    chunkIndex: number,
    lastSuccessMessage: string
  ) {
    if (chunkIndex >= dataChunks.length) {
      this.bulkActionProgressing = false;
      this.stopBatchProcessing();
      const defaultMessage =
        type === '1' ? 'Invoice(s) approved successfully' : 'Invoice(s) rejected successfully';
      this.completeBulkApprovalAfterRequests(lastSuccessMessage || defaultMessage);
      return;
    }
    const requestObj = {
      company_id:
        this._localStorageService.getEmpCompanyId() == undefined
          ? '0'
          : this._localStorageService.getEmpCompanyId(),
      data_for_approval: dataChunks[chunkIndex]
    };
    this.webService
      .commonPostMethod('all_company_analytical_data/multi_company_bulk_invoice_approval', requestObj)
      .subscribe(
        data => {
          this.appendBulkValidationErrorsFromResponse(data);
          const defaultMessage =
            type === '1'
              ? 'Invoice(s) approved successfully'
              : 'Invoice(s) rejected successfully';
          const nextMessage = (data && data.message) || lastSuccessMessage || defaultMessage;
          this.submitBulkApprovalInBatches(dataChunks, type, chunkIndex + 1, nextMessage);
        },
        error => {
          if (chunkIndex > 0) {
            this.handleBulkApprovalPartialBatchFailure(
              dataChunks,
              type,
              chunkIndex,
              lastSuccessMessage,
              error
            );
            return;
          }
          this.bulkActionProgressing = false;
          this.stopBatchProcessing();
          this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          this.cancelBulkAction();
        }
      );
  }

  private getBulkApprovalSuccessInvoiceCount(dataChunks: any[][], failedChunkIndex: number): number {
    let count = 0;
    for (let i = 0; i < failedChunkIndex && i < dataChunks.length; i++) {
      if (dataChunks[i] && dataChunks[i].length > 0) {
        count += dataChunks[i].length;
      }
    }
    return count;
  }

  private getBulkApprovalHttpErrorMessage(error: any): string {
    if (!error) {
      return 'Network error';
    }
    const status = error.status != undefined && error.status != null ? error.status : null;
    if (status === 504) {
      return '504 Gateway Timeout';
    }
    if (status) {
      return 'HTTP ' + status;
    }
    return 'Network error';
  }

  private appendBulkValidationErrorsFromFailedChunk(failedChunk: any[], errorMessage: string): void {
    if (!failedChunk || failedChunk.length <= 0) {
      return;
    }
    for (const item of failedChunk) {
      if (!item) {
        continue;
      }
      this.aggregatedBulkValidationErrors.push({
        company_id: item.company_id,
        invoice_id: item.invoice_id,
        error: errorMessage
      });
    }
  }

  private handleBulkApprovalPartialBatchFailure(
    dataChunks: any[][],
    type: string,
    failedChunkIndex: number,
    lastSuccessMessage: string,
    error: any
  ): void {
    this.bulkActionProgressing = false;
    this.stopBatchProcessing();
    const failedChunk = dataChunks[failedChunkIndex] || [];
    const successCount = this.getBulkApprovalSuccessInvoiceCount(dataChunks, failedChunkIndex);
    const httpErrorMessage = this.getBulkApprovalHttpErrorMessage(error);
    this.appendBulkValidationErrorsFromFailedChunk(
      failedChunk,
      'Request failed — ' +
        httpErrorMessage +
        '. Please verify status in the list and retry if needed.'
    );
    const actionLabel = type === '1' ? 'approved' : 'rejected';
    let partialMessage =
      successCount +
      ' invoice(s) ' +
      actionLabel +
      ' successfully. ' +
      failedChunk.length +
      ' invoice(s) could not be completed (' +
      httpErrorMessage +
      '). Please refresh and retry the remaining invoice(s).';
    if (lastSuccessMessage) {
      partialMessage = lastSuccessMessage + ' ' + partialMessage;
    }
    this.completeBulkApprovalAfterRequests(partialMessage);
  }

  private resetBulkValidationErrors(): void {
    this.aggregatedBulkValidationErrors = [];
    this.showBulkValidationErrorsDialog = false;
  }

  private appendBulkValidationErrorsFromResponse(data: any): void {
    if (!data || !data.validation_errors || !Array.isArray(data.validation_errors)) {
      return;
    }
    for (const item of data.validation_errors) {
      if (item) {
        this.aggregatedBulkValidationErrors.push(item);
      }
    }
  }

  closeBulkValidationErrorsDialog(): void {
    this.showBulkValidationErrorsDialog = false;
  }

  private completeBulkApprovalAfterRequests(message: string): void {
    if (this.aggregatedBulkValidationErrors.length > 0) {
      this.showBulkValidationErrorsDialog = true;
      if (message) {
        this.toasterService.pop('warning', 'Warning', message);
      }
      this.cancelBulkAction();
      if (this.isBulkApprovalAction) {
        this.clearSelectedInvoices();
      }
      this.getAllInvoicesForApproval(this.currentPage, false, this.searchinput, '1');
      return;
    }
    this.finishBulkApprovalSuccess(message);
  }

  finishBulkApprovalSuccess(message: string) {
    this.toasterService.pop('success', 'Success', message);
    this.cancelBulkAction();
    if (this.isBulkApprovalAction) {
      this.clearSelectedInvoices();
    }
    this.getAllInvoicesForApproval(this.currentPage, false, this.searchinput, '1');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src692328540/src/src/app/all-company-dashboard/pending-invoices-popup/pending-invoices-popup.component.ts